import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../_interface/control-template.enum';
import {isControlRequired} from '../functions/check-if-control-required.fn';
import {NgSelectComponent} from '@ng-select/ng-select';
import {FormFieldWarnings} from '../../../../journal/src/_interface/form-field-warnings.interface';

type IndexedOptions = {key: any, index: number};

@Component({
	selector: 'form-select',
	templateUrl: './select.component.html',
	styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

	@ViewChild('ngSelect', {static: false}) ngSelect: NgSelectComponent;

	@Input() control: UntypedFormControl;
	@Input() options: string[];
	@Input() id: string = this.dynamicIdService.getId('select-input');
	@Input() label: string;
	@Input() multiple = false;
	@Input() placeholder: string;
	@Input() template: ControlTemplate = ControlTemplate.horizontal;
	@Input() set setWarnings(warnings: FormFieldWarnings) {
		this.warnings = warnings;
	}

	ControlTemplate = ControlTemplate;
	isControlRequired: boolean;
	warnings: FormFieldWarnings;
	selectOpen = false;

	innerOptions: IndexedOptions[] = [];

	constructor(private dynamicIdService: DynamicIdService) {
	}

	private setInnerOptions() {
		if (!this.options?.length) return;
		this.innerOptions = this.mapPlainToIndexedObjects(this.options);
		this.checkIndexValueForLegacyTemplateFields();
	}

	private mapPlainToIndexedObjects(items: any[]): IndexedOptions[] {
		return items.map((key, index) => ({key, index}));
	}

	ngOnInit(): void {
		if (!this.control) throw new Error('Control is required');
		if (this.multiple) this.setInnerOptions();
		this.isControlRequired = isControlRequired(this.control);
	}

	compareWithIndex(...args: any[]): boolean {
		const [a, b] = args;
		return a.key === b.key && +a.index === +b.index;
	}

	openSelect() {
		this.control.markAsTouched();
		this.control.markAsDirty();
		this.ngSelect.open();
	}

	checkSelectValue() {
		if (this.control.value?.length) return;
		this.clear();
	}

	clear() {
		this.control.reset();
		this.control.markAsDirty();
		this.control.markAsTouched();
		this.control.markAsPristine();
	}

	checkIndexValueForLegacyTemplateFields() {
		if (!this.control.value) return;
		const indexedValues = this.control.value.map((v: {key: string, index: string}) => {
			const {key, index} = v;
			if (!index) return {key, index: this.innerOptions.findIndex((i) => i.key === key)};
			return v;
		});
		this.control.patchValue(indexedValues);
	}
}
